import ItemView from 'view/baseItemView';

class NewsItemView extends ItemView {
  constructor() {
    super();
    this.className = 'NewsItemView';
  }
}

export default NewsItemView;